<div class="outer-border mt-5">
  <div
    *ngIf="isLoadingResults"
    class="w-100 border-bottom align-items-center d-flex justify-content-center white-background"
  >
    <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
  </div>
  <mat-table #table [dataSource]="dataSource" class="table">
    <ng-container matColumnDef="descricao">
      <mat-header-cell *matHeaderCellDef class="pl-3">Descricão</mat-header-cell>
      <mat-cell *matCellDef="let row" [class.dark-secondary-text]="isLoadingResults">
        {{ row?.descricao | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="duracao">
      <mat-header-cell *matHeaderCellDef>Duração</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row?.duracao | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tipo">
      <mat-header-cell *matHeaderCellDef>Tipo</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row?.tipo.descricao | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row" class="d-flex align-items-center pr-2 justify-content-end">
        <bdg-icon-button icon="edit" [disabled]="isLoadingResults" (click)="onClickEditarDuracao(row)">
        </bdg-icon-button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <div
    *ngIf="dataSource.data.length === 0 && !isLoadingResults"
    class="w-100 border-bottom text-center table-message white-background"
  >
    <bdg-label color="rgba(0, 0, 0, 0.54); font-style: italic;">
      Nenhuma área de atuacão encontrada com os filtros aplicados. Confira as informações e realize outra busca.
    </bdg-label>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
<div class="w-100" style="height: 1em"></div>
